<template>
    <!-- Start Google MAp -->
    <div class="google-map-style-1">
        <iframe src="http://www.yaoxiegm.com/map.html" width="800" height="450" style="border:0;" allowfullscreen="" loading="lazy"></iframe>
    </div>
    <!-- End Google MAp -->
</template>

<script>
    export default {
        name: 'GoogleMap'
    }
</script>